/**
 * Fonte única do canal de atendimento via WhatsApp. Todo ponto de entrada do
 * canal (popup flutuante, área de contatos do footer, etc) deve consumir daqui
 * para que o número e a mensagem inicial não divirjam entre as telas.
 *
 * O número vem de NEXT_PUBLIC_WHATSAPP_SAC_PHONE para poder ser trocado por
 * ambiente sem novo deploy. O valor abaixo é o padrão de produção e existe para
 * o canal não sumir caso a variável não esteja configurada.
 */
const DEFAULT_WHATSAPP_SAC_PHONE = '5544988488282'

export const WHATSAPP_SAC_PHONE =
  process.env.NEXT_PUBLIC_WHATSAPP_SAC_PHONE || DEFAULT_WHATSAPP_SAC_PHONE

export const WHATSAPP_SAC_MESSAGE =
  'Olá, será um prazer ajudar, envie uma mensagem para visualizar o menu de atendimento e escolha a opção "Pedidos online". Aguardo seu contato'

export function getWhatsAppSacUrl(
  phone: string = WHATSAPP_SAC_PHONE,
  message: string = WHATSAPP_SAC_MESSAGE
) {
  return `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(
    message
  )}`
}
